export const PLANES = [
  { value: 'complementario', label: 'Plan Complementario Especial' },
  { value: 'vital', label: 'Plan Vital' },
  { value: 'beneficios', label: 'Plan Beneficios en Salud' }
];

export const TIPOS_DOCUMENTO = [
  { value: '', label: 'Seleccione' },
  { value: '1', label: 'Cédula de Ciudadanía' },
  { value: '4', label: 'Cédula de Extranjería' },
  { value: '5', label: 'Pasaporte' },
  { value: '2', label: 'NIT' },
  { value: '14', label: 'Permiso de protección temporal' }
];

export const SALESFORCE_CONFIG = {
  ORG_ID: '00DVC000006UPvB',
  WEB_TO_LEAD_URL:
    'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DVC000006UPvB'
};

export const FORM_CONFIG = {
  SHAREPOINT_LIST_NAME: 'FormularioContacto',
  SUBMIT_DELAY: 4000
};

export const TIPO_DOCUMENTO = {
  CC: '1',
  CE: '4',
  PA: '5',
  NIT: '2',
  PPT: '14'
};